import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';

interface VideoCardProps {
  video: Video;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-video overflow-hidden">
        <img
          src={video.cover}
          alt={`${video.title} 封面`}
          title={`${video.title} - 糖心视频`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-foreground-950/70 text-background-50 text-xs font-medium">
          {video.categoryLabel}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-foreground-950 text-xs font-bold flex items-center gap-1">
          <i className="ri-star-fill text-[10px]"></i>
          {video.rating.toFixed(1)}
        </span>
        <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-xl"></i>
          </span>
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
          <span>{video.year}</span>
          <span className="text-background-300">·</span>
          <span className="truncate">{video.region}</span>
          <span className="text-background-300">·</span>
          <span className="truncate">{video.genre}</span>
        </div>
      </div>
    </Link>
  );
}